import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react"
import { RootState } from "../../app/store"

const BASE_URL = import.meta.env.VITE_REACT_APP_API_URL

export const emailVerifyAuth = createApi({
  reducerPath: "emailVerifyAuth",

  baseQuery: fetchBaseQuery({
    baseUrl: `${BASE_URL}/api/provider/`,
    prepareHeaders: (headers, { getState }) => {
      const emailVerifyToken = (getState() as RootState).emailVerifySlice
        .emailVerifyToken

      if (emailVerifyToken) {
        headers.set("authorization", `Bearer ${emailVerifyToken}`)
      }
      return headers
    },
  }),
  tagTypes: ["appointments", `upComingappointment`],
  endpoints: (builder) => ({
    emailVerify: builder.query<any, {token: string | null}>({
      query: ({token}) => ({
        url: "verify-email",
        method: "GET",
        headers: {
          Authorization: token ? `Bearer ${token}` : '',
        },
      }),
    }),

    protected: builder.mutation<{ message: string }, void>({
      query: () => "protected",
    }),
  }),
})

export const { useEmailVerifyQuery } = emailVerifyAuth
